import { render, staticRenderFns } from "./PractitionerSummaryReport.vue?vue&type=template&id=77313df6&"
import script from "./PractitionerSummaryReport.vue?vue&type=script&lang=js&"
export * from "./PractitionerSummaryReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports